export default __webpack_public_path__ + "static/media/nextjs.726188da.svg";